"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("../../new-components");
var _booking = require("../../helpers/booking");
var _WeekRowButton = _interopRequireDefault(require("./components/WeekRowButton"));
var WeekRowPill = function WeekRowPill(_ref) {
  var weekRow = _ref.weekRow;
  if (weekRow.soldOut) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "margin-left-sm pill pill--sm pill--black"
    }, "Sold out");
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, weekRow.highDemand && /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-right-sm margin-y-sm pill pill--sm pill--primary"
  }, "Limited availability"), weekRow.comingSoon && /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-right-sm margin-y-sm pill pill--sm pill--standard"
  }, "Coming soon"));
};
WeekRowPill.propTypes = {
  weekRow: _propTypes["default"].object.isRequired
};
var WeekRow = function WeekRow(_ref2) {
  var weekRow = _ref2.weekRow,
    isLast = _ref2.isLast;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center width-100%".concat(isLast ? '' : ' margin-bottom-md')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_newComponents.Avatar, {
    avatarSize: _newComponents.AVATAR_SIZES.MEDIUM,
    avatarType: _newComponents.AVATAR_TYPES.SQUARE,
    image: {
      url: weekRow.image.url,
      alt: weekRow.image.alt
    },
    disabled: weekRow.soldOut
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-left-md flex flex-wrap items-center justify-between width-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-contrast-high margin-right-sm text-sm"
  }, weekRow.week.name || "Week ".concat(weekRow.week.week)), /*#__PURE__*/_react["default"].createElement(WeekRowPill, {
    weekRow: weekRow
  })), weekRow.eventMusic && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm margin-bottom-xs d8-u-color-contrast-medium flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
    className: "icon--sm margin-right-xxs",
    name: "music",
    fill: _newComponents.COLORS.CONTRAST_MEDIUM
  }), weekRow.eventMusicLink ? /*#__PURE__*/_react["default"].createElement(_newComponents.Link, {
    href: weekRow.eventMusicLink,
    external: true,
    className: "d8-u-color-contrast-medium"
  }, weekRow.eventMusic) : /*#__PURE__*/_react["default"].createElement("span", null, weekRow.eventMusic))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-y-xxxs"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-bold"
  }, (0, _booking.getWeekString)(weekRow.week)))), /*#__PURE__*/_react["default"].createElement(_WeekRowButton["default"], {
    weekRow: weekRow
  })));
};
WeekRow.propTypes = {
  weekRow: _propTypes["default"].object.isRequired,
  isLast: _propTypes["default"].bool
};
var _default = exports["default"] = WeekRow;